import type { AiChatbotChunkEntity } from "../../../../services/server-side-events-ai-chatbot/entities/ai-chatbot-chunk.entity";
import { StreamMessageRepository } from "../../repositories/stream-message/stream-message-repository";
import type { IStreamMessageRepository } from "../../repositories/stream-message/stream-message.repository.interface";
import type { IStreamMessageService } from "./stream-message-service.interface";

export class StreamMessageService implements IStreamMessageService {
  constructor(private _eventSourceRepository: IStreamMessageRepository = new StreamMessageRepository()) {}

  public listen(eventCallback: (message: AiChatbotChunkEntity) => void, errorCallback: (message: Error) => void): void {
    this._eventSourceRepository.listen(eventCallback, errorCallback);
  }

  public close(): void {
    this._eventSourceRepository.close();
  }
}
